module.exports = __webpack_public_path__ + "static/media/icn_corona_fisdom.751c09b4.svg";